
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BioentityLiveDataGraphQL"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistryItemInterface"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistryItemInterface"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayLabel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"archiveRecord"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purpose"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tagsJson"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SequenceNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bases"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"basesIfShowResidues"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"circular"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modifiedNucleotides"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sugarMonomerId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baseMonomerId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phosphateMonomerId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"helmString"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idtString"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customSyntaxString"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AaSequenceNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"versionJson"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MoleculeNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canonicalSmiles"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"bioentityAliasInfos"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alias"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"registryCollectionOwnerJson"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1032}};
    doc.loc.source = {"body":"  # Keep in sync with the server-side resync fetch fetch_bioentity_live_data in\n  # benchling/notebook/structured_tables/resync/bioentity_live_data/bioentity_live_data.py, which selects\n  # this fragment so backend resync reads the same bioentity live-data shape as the frontend.\n  fragment BioentityLiveDataGraphQL on RegistryItemInterface {\n    ... on RegistryItemInterface {\n      id\n      name\n      displayLabel\n      archiveRecord {\n        purpose\n      }\n      tagsJson\n      ... on SequenceNode {\n        id\n        bases\n        basesIfShowResidues\n        circular\n        modifiedNucleotides {\n          position\n          sugarMonomerId\n          baseMonomerId\n          phosphateMonomerId\n        }\n        helmString\n        idtString\n        customSyntaxString\n      }\n      ... on AaSequenceNode {\n        id\n        versionJson\n      }\n      ... on MoleculeNode {\n        id\n        canonicalSmiles\n      }\n      bioentityAliasInfos {\n        id\n        alias\n        registryCollectionOwnerJson\n      }\n    }\n  }\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["BioentityLiveDataGraphQL"] = oneQuery(doc, "BioentityLiveDataGraphQL");
        
